import React from 'react';
import clsx from 'clsx';

export interface DesktopDialogProps {
  children: React.ReactNode;
  className?: string;
  role?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const DesktopDialog: React.FC<DesktopDialogProps> = ({
  children,
  className,
  role = 'dialog',
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  onClick,
}) => (
  <div
    className={clsx('desktop-dialog', className)}
    role={role}
    aria-modal="true"
    aria-label={ariaLabel}
    aria-labelledby={ariaLabelledBy}
    onClick={onClick}
  >
    {children}
  </div>
);

export default DesktopDialog;
